(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    root = root && root.querySelectorAll ? root : document;
    root.querySelectorAll('[data-sv-bundle]').forEach(function (section) {
      if (section.dataset.svBundleReady === 'true') return;
      section.dataset.svBundleReady = 'true';

      var button = section.querySelector('[data-sv-bundle-add]');
      if (!button) return;
      var errorBox = section.querySelector('[data-sv-bundle-error]');
      var pending = false; // one request (plus its "Added" flash) at a time

      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (pending || button.disabled) return;

        var SV = window.SV || {};
        var routes = SV.routes || {};
        var cartUrl = routes.cart || '/cart';
        var strings = SV.strings || {};

        // Items: the pillow's variant and, only when a pillowcase product is
        // assigned, its variant. With data-variant-2 absent (pillowcase
        // included in the box) a single item is added through the very same
        // request and the drawer opens exactly as in the 2-item case. The
        // button only degrades to the /cart link when there is no variant at
        // all or SV.addToCart is unavailable.
        var items = [];
        var v1 = button.getAttribute('data-variant-1');
        var v2 = button.getAttribute('data-variant-2');
        if (v1) items.push({ id: v1, quantity: 1 });
        if (v2) items.push({ id: v2, quantity: 1 });

        // Bundle tag: when the pillow AND the pillowcase are added, both lines
        // carry the same hidden properties (_bundle / _bundle_title; the "_"
        // prefix keeps them out of checkout) so the cart drawer can group them
        // as one offer. A single variant is added without properties.
        if (v1 && v2) {
          var bundleKey = button.getAttribute('data-bundle-key') || 'bundle';
          var bundleTitle = button.getAttribute('data-bundle-title') || '';
          items.forEach(function (item) {
            item.properties = { _bundle: bundleKey, _bundle_title: bundleTitle };
          });
        }

        if (!items.length || typeof SV.addToCart !== 'function') {
          window.location.href = cartUrl;
          return;
        }

        var original = button.textContent;
        pending = true;
        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (strings.adding) button.textContent = strings.adding;
        if (errorBox) {
          errorBox.textContent = '';
          errorBox.setAttribute('hidden', '');
        }

        SV.addToCart(items, { opener: button })
          .then(function () {
            // Cart type "drawer": SV.addToCart has already re-rendered and
            // opened the cart drawer — stay on the page. Otherwise keep the
            // previous behaviour and go to the cart page.
            var drawerEnabled = SV.cart && typeof SV.cart.enabled === 'function' && SV.cart.enabled();
            if (!drawerEnabled) {
              window.location.href = cartUrl; // button stays locked while navigating away
              return;
            }
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            button.disabled = false;
            if (strings.added) {
              button.textContent = strings.added;
              window.setTimeout(function () {
                button.textContent = original;
                pending = false;
              }, 1500);
            } else {
              button.textContent = original;
              pending = false;
            }
          })
          .catch(function (err) {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            button.disabled = false;
            button.textContent = original;
            pending = false;
            // Disabling the focused button drops focus in some browsers: hand it back
            if (document.activeElement === document.body) button.focus();
            var message = (err && err.message) || strings.cartError || 'Something went wrong. Please try again.';
            if (errorBox) {
              // Reveal first, then populate: a live region that changes while
              // display:none is not reliably announced by screen readers.
              errorBox.removeAttribute('hidden');
              window.requestAnimationFrame(function () {
                errorBox.textContent = message;
              });
            } else {
              window.alert(message);
            }
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["config-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Theme editor: when a slide block is selected, scroll its carousel to it.
     Everything else (arrows, disabled state) is the generic Carousel behaviour
     in assets/slumbervale.js. */
  if (document.documentElement.dataset.svConfigsReady === 'true') return;
  document.documentElement.dataset.svConfigsReady = 'true';

  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var slide = target.closest('[data-sv-configs-slide]');
    if (!slide) return;
    var scroller = slide.closest('.sv-scroller');
    if (!scroller) return;
    var left = slide.offsetLeft - scroller.offsetLeft;
    scroller.scrollTo({ left: left, behavior: 'auto' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Theme editor nicety: open the matching accordion when a block is selected.
     Guard against double-binding with a DOM flag (no globals leaked). */
  var rootEl = document.documentElement;
  if (rootEl.hasAttribute('data-sv-faq-editor')) return;
  rootEl.setAttribute('data-sv-faq-editor', '');

  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var item = target.closest('[data-sv-faq-item]');
    if (!item) return;
    var section = item.closest('[data-sv-faq]');
    if (section) {
      section.querySelectorAll('[data-sv-faq-item]').forEach(function (other) {
        if (other !== item) other.removeAttribute('open');
      });
    }
    item.setAttribute('open', '');
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var item = target.closest('[data-sv-faq-item]');
    if (item) item.removeAttribute('open');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var READY = 'svFeaturesReady';

  function setLabel(btn, expanded) {
    var label = expanded ? btn.getAttribute('data-label-close') : btn.getAttribute('data-label-open');
    if (label) btn.setAttribute('aria-label', label);
  }

  function init(root) {
    root = root && root.querySelectorAll ? root : document;
    root.querySelectorAll('[data-sv-features-toggle]').forEach(function (btn) {
      if (btn.dataset[READY] === 'true') return;
      btn.dataset[READY] = 'true';
      setLabel(btn, btn.getAttribute('aria-expanded') === 'true');
    });
  }

  /* Swap the accessible name when the generic Toggle opens/closes the overlay. */
  document.addEventListener('sv:toggle', function (event) {
    var btn = event.detail && event.detail.button;
    if (btn && btn.hasAttribute && btn.hasAttribute('data-sv-features-toggle')) {
      setLabel(btn, !!event.detail.expanded);
    }
  });

  /* Escape closes any open overlay and returns focus to its button. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-sv-features-toggle][aria-expanded="true"]').forEach(function (btn) {
      btn.click();
      btn.focus();
    });
  });

  /* Theme editor: bring the selected card into view inside the mobile carousel. */
  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    var card = target && target.closest ? target.closest('.sv-features__card') : null;
    var scroller = card ? card.closest('.sv-scroller') : null;
    if (!card || !scroller || scroller.scrollWidth <= scroller.clientWidth + 1) return;
    var cr = card.getBoundingClientRect();
    var sr = scroller.getBoundingClientRect();
    scroller.scrollBy({ left: cr.left - sr.left - 16, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  var READY = 'svFooterCountryReady';
  var DESKTOP = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;

  function isDesktop() {
    return !!(DESKTOP && DESKTOP.matches);
  }

  /* Menu blocks are a single <details> each: closed accordions on mobile,
     always-open columns on desktop (the summary is inert there via CSS). */
  function syncBlocks(scope) {
    var desktop = isDesktop();
    scope.querySelectorAll('[data-sv-footer-block]').forEach(function (details) {
      var summary = details.querySelector('summary');
      if (desktop) {
        details.open = true;
        if (summary) summary.setAttribute('tabindex', '-1');
      } else {
        details.open = false;
        if (summary) summary.removeAttribute('tabindex');
      }
    });
  }

  function initCountry(scope) {
    scope.querySelectorAll('[data-sv-footer-country]').forEach(function (select) {
      if (select.dataset[READY] === 'true') return;
      select.dataset[READY] = 'true';
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initCountry(scope);
    syncBlocks(scope);
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (DESKTOP) {
    var onBreakpointChange = function () {
      syncBlocks(document);
    };
    if (DESKTOP.addEventListener) {
      DESKTOP.addEventListener('change', onBreakpointChange);
    } else if (DESKTOP.addListener) {
      DESKTOP.addListener(onBreakpointChange);
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  /* Theme editor: reveal a menu block's links when it is selected in a small
     preview, and fold it back when deselected. */
  function blockFromEvent(event) {
    var target = event && event.target;
    if (!target || !target.closest) return null;
    return target.closest('[data-sv-footer-block]');
  }

  document.addEventListener('shopify:block:select', function (event) {
    var details = blockFromEvent(event);
    if (details && !isDesktop()) details.open = true;
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var details = blockFromEvent(event);
    if (details && !isDesktop()) details.open = false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    'use strict';

    var DESKTOP_QUERY = '(min-width: 990px)';
    var BOUND_FLAG = 'svHeaderBound';

    function headers() {
      return document.querySelectorAll('[data-sv-header]');
    }

    function isScrolled() {
      return (window.scrollY || window.pageYOffset || 0) > 4;
    }

    function closeDrawer(drawer) {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      if (window.SV && window.SV.Drawer && typeof window.SV.Drawer.close === 'function') {
        window.SV.Drawer.close(drawer);
        return;
      }
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sv-no-scroll');
    }

    function renderCount(cart) {
      if (!cart) return;
      var count = typeof cart.item_count === 'number' ? cart.item_count : parseInt(cart.item_count, 10) || 0;
      document.querySelectorAll('[data-sv-header] [data-sv-cart-count]').forEach(function (el) {
        el.textContent = String(count);
        if (count > 0) {
          el.removeAttribute('hidden');
          el.classList.add('is-visible');
        } else {
          el.setAttribute('hidden', '');
          el.classList.remove('is-visible');
        }
      });
    }

    /* Sticky: subtle shadow once the page has scrolled. Acts on every header
       present at call time, so editor reloads never leave stale listeners. */
    function updateScrolled() {
      var scrolled = isScrolled();
      headers().forEach(function (header) {
        if (header.getAttribute('data-sv-header-sticky') !== 'true') return;
        header.classList.toggle('is-scrolled', scrolled);
      });
    }

    /* Close any open header drawer (viewport grew to desktop). The logo-only
       layout has no drawer attribute, so nothing happens there. */
    function closeHeaderDrawers() {
      headers().forEach(function (header) {
        var drawerId = header.getAttribute('data-sv-header-drawer');
        closeDrawer(drawerId ? document.getElementById(drawerId) : null);
      });
    }

    function initHeader(header) {
      if (header.dataset.svHeaderReady === 'true') return;
      header.dataset.svHeaderReady = 'true';
      if (header.getAttribute('data-sv-header-sticky') === 'true') {
        header.classList.toggle('is-scrolled', isScrolled());
      }
    }

    function init(root) {
      root = root && root.querySelectorAll ? root : document;
      root.querySelectorAll('[data-sv-header]').forEach(initHeader);
    }

    /* Global listeners, bound once per document. The flag lives on <html>
       (no window global); every handler looks the headers up at call time. */
    if (document.documentElement.dataset[BOUND_FLAG] !== 'true') {
      document.documentElement.dataset[BOUND_FLAG] = 'true';

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateScrolled();
          ticking = false;
        });
      }, { passive: true });

      if (window.matchMedia) {
        var mq = window.matchMedia(DESKTOP_QUERY);
        var onChange = function (event) {
          if (event.matches) closeHeaderDrawers();
        };
        if (typeof mq.addEventListener === 'function') {
          mq.addEventListener('change', onChange);
        } else if (typeof mq.addListener === 'function') {
          mq.addListener(onChange);
        }
      }

      document.addEventListener('sv:cart:updated', function (event) {
        renderCount(event.detail);
      });

      /* Refresh the bubble when the page is restored from the back/forward cache */
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;
        if (window.SV && typeof window.SV.fetchCart === 'function') {
          window.SV.fetchCart().then(renderCount).catch(function () {});
        }
      });

      document.addEventListener('shopify:section:load', function (event) {
        init(event.target || document);
      });

      document.addEventListener('shopify:section:unload', function (event) {
        var target = event.target;
        if (target && target.querySelector) {
          var open = target.querySelector('.sv-drawer.is-open');
          if (open) document.body.classList.remove('sv-no-scroll');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function () {
  function setOpen(section, id, open) {
    var panel = document.getElementById(id);
    if (!panel) return;
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
    var openers = section.querySelectorAll('[data-sv-address-open="' + id + '"]');
    openers.forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      var first = panel.querySelector('input:not([type="hidden"]), select, textarea');
      if (first) first.focus({ preventScroll: true });
      panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    } else if (openers.length) {
      openers[0].focus({ preventScroll: true });
    }
  }

  function initCountrySelects(form) {
    var country = form.querySelector('[data-sv-country]');
    var province = form.querySelector('[data-sv-province]');
    var wrap = form.querySelector('[data-sv-province-wrap]');
    if (!country || !province || !wrap) return;

    var defaultCountry = country.getAttribute('data-default');
    var defaultProvince = province.getAttribute('data-default');

    if (defaultCountry) {
      for (var i = 0; i < country.options.length; i++) {
        if (country.options[i].value === defaultCountry || country.options[i].textContent.trim() === defaultCountry) {
          country.selectedIndex = i;
          break;
        }
      }
    }

    function update() {
      var option = country.options[country.selectedIndex];
      var raw = option ? option.getAttribute('data-provinces') : null;
      var provinces = [];
      if (raw) {
        try {
          provinces = JSON.parse(raw);
        } catch (err) {
          provinces = [];
        }
      }
      province.innerHTML = '';
      if (!provinces.length) {
        wrap.setAttribute('hidden', '');
        return;
      }
      provinces.forEach(function (pair) {
        var opt = document.createElement('option');
        opt.value = pair[0];
        opt.textContent = pair[1];
        if (defaultProvince && pair[0] === defaultProvince) opt.selected = true;
        province.appendChild(opt);
      });
      wrap.removeAttribute('hidden');
    }

    country.addEventListener('change', update);
    update();
  }

  function initAddresses(root) {
    root.querySelectorAll('[data-sv-addresses]').forEach(function (section) {
      if (section.dataset.svAddressesReady === 'true') return;
      section.dataset.svAddressesReady = 'true';

      section.querySelectorAll('[data-sv-address-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-sv-address-open');
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          setOpen(section, id, !isOpen);
        });
      });

      section.querySelectorAll('[data-sv-address-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setOpen(section, btn.getAttribute('data-sv-address-close'), false);
        });
      });

      section.querySelectorAll('[data-sv-address-form]').forEach(initCountrySelects);

      section.querySelectorAll('form[data-sv-confirm]').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          var message = form.getAttribute('data-sv-confirm');
          if (message && !window.confirm(message)) event.preventDefault();
        });
      });
    });
  }

  function run() {
    initAddresses(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAddresses(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function initCart(root) {
    root = root && root.querySelectorAll ? root : document;
    root.querySelectorAll('form.sv-cart__form').forEach(function (form) {
      if (form.dataset.svCartReady === 'true') return;
      form.dataset.svCartReady = 'true';

      var updateBtn = form.querySelector('[data-sv-cart-update]');
      var timer = null;

      function submitUpdate() {
        window.clearTimeout(timer);
        if (updateBtn && typeof form.requestSubmit === 'function') {
          form.requestSubmit(updateBtn);
        } else if (updateBtn) {
          updateBtn.click();
        } else {
          form.submit();
        }
      }

      form.querySelectorAll('[data-sv-cart-qty]').forEach(function (input) {
        input.addEventListener('change', function () {
          var value = parseInt(input.value, 10);
          if (isNaN(value) || value < 0) {
            input.value = 0;
          }
          window.clearTimeout(timer);
          timer = window.setTimeout(submitUpdate, 400);
        });

        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            submitUpdate();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCart(document);
    });
  } else {
    initCart(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCart(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
(function () {
  function initLogin(root) {
    root.querySelectorAll('[data-sv-login]').forEach(function (section) {
      if (section.dataset.svLoginReady === 'true') return;
      section.dataset.svLoginReady = 'true';

      var panels = section.querySelectorAll('[data-sv-login-panel]');
      var switches = section.querySelectorAll('[data-sv-login-switch]');

      function show(key) {
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-sv-login-panel') === key;
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
        switches.forEach(function (btn) {
          if (btn.hasAttribute('aria-expanded')) {
            btn.setAttribute('aria-expanded', btn.getAttribute('data-sv-login-switch') === key ? 'true' : 'false');
          }
        });
        var target = section.querySelector('[data-sv-login-panel="' + key + '"]');
        if (target) {
          var focusable = target.querySelector('input, button');
          if (focusable) focusable.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }

      switches.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          show(btn.getAttribute('data-sv-login-switch'));
        });
      });

      if (window.location.hash === '#recover') show('recover');
    });
  }

  function run() {
    initLogin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initLogin(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  'use strict';

  var READY = 'svProductReady';

  function once(el) {
    if (el.dataset[READY] === 'true') return false;
    el.dataset[READY] = 'true';
    return true;
  }

  /* Gallery: thumbnails swap the visible slide in the main slot */
  function initGallery(root) {
    root.querySelectorAll('[data-sv-product-gallery]').forEach(function (gallery) {
      if (!once(gallery)) return;
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-sv-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-sv-thumb]'));
      if (!slides.length || !thumbs.length) return;

      function show(key) {
        slides.forEach(function (slide) {
          var active = slide.getAttribute('data-sv-slide') === key;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('hidden');
          } else {
            slide.setAttribute('hidden', '');
          }
        });
        thumbs.forEach(function (thumb) {
          var active = thumb.getAttribute('data-sv-thumb') === key;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          show(thumb.getAttribute('data-sv-thumb'));
        });
      });

      /* Touch swipe on the main image (mobile): left = next, right = previous, wrapping */
      var main = gallery.querySelector('.sv-product__main');
      if (main) {
        var keys = slides.map(function (slide) { return slide.getAttribute('data-sv-slide'); });
        var startX = 0, startY = 0, tracking = false;
        function currentIndex() {
          for (var i = 0; i < slides.length; i++) {
            if (!slides[i].hasAttribute('hidden')) return i;
          }
          return 0;
        }
        function step(delta) {
          var next = (currentIndex() + delta + keys.length) % keys.length;
          show(keys[next]);
        }
        /* Desktop (>= 990px) shows the lifestyle grid instead of thumbs: no swipe there */
        function isMobileLayout() {
          return !window.matchMedia || window.matchMedia('(max-width: 989px)').matches;
        }
        main.addEventListener('touchstart', function (event) {
          if (event.touches.length !== 1) { tracking = false; return; }
          tracking = true;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        }, { passive: true });
        main.addEventListener('touchend', function (event) {
          if (!tracking) return;
          tracking = false;
          var touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          if (!isMobileLayout()) return;
          step(dx < 0 ? 1 : -1);
        }, { passive: true });
        main.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
      }
    });
  }

  /* Rating row: scroll to the reviews section wherever it lives.
     Shopify gives JSON-template sections ids like template--<id>__reviews, so the
     href is only a fallback; the jump itself is class-based (.sv-reviews). */
  function initRatingLinks(root) {
    root.querySelectorAll('[data-sv-product-reviews-link]').forEach(function (link) {
      if (!once(link)) return;
      link.addEventListener('click', function (event) {
        var target = document.querySelector('.sv-reviews');
        if (!target) {
          var href = link.getAttribute('href') || '';
          if (href.charAt(0) === '#' && href.length > 1) {
            try {
              target = document.querySelector(href);
            } catch (err) {
              target = null;
            }
          }
        }
        if (!target) return;
        event.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* Price block: rewrite current / compare-at / sold-out for the chosen variant.
     The price snippet omits <s class="sv-price__compare"> when the first variant
     is not on sale, so the element is created on demand. */
  function srOnly(text) {
    var span = document.createElement('span');
    span.className = 'sv-visually-hidden';
    span.textContent = text;
    return span;
  }

  function updatePrice(priceEl, price, compare, available, soldoutLabel) {
    var onSale = !!compare;
    var current = priceEl.querySelector('.sv-price__current');
    var compareEl = priceEl.querySelector('.sv-price__compare');
    var soldout = priceEl.querySelector('.sv-price__soldout');

    if (!current) {
      current = document.createElement('span');
      current.className = 'sv-price__current';
      priceEl.appendChild(current);
    }
    if (!compareEl) {
      compareEl = document.createElement('s');
      compareEl.className = 'sv-price__compare';
      priceEl.insertBefore(compareEl, current);
    }

    if (price) {
      current.textContent = '';
      if (onSale) current.appendChild(srOnly('Sale price '));
      current.appendChild(document.createTextNode(price));
    }

    compareEl.textContent = '';
    if (onSale) {
      compareEl.appendChild(srOnly('Regular price '));
      compareEl.appendChild(document.createTextNode(compare));
      compareEl.removeAttribute('hidden');
    } else {
      compareEl.setAttribute('hidden', '');
    }
    priceEl.classList.toggle('sv-price--on-sale', onSale);

    if (available) {
      if (soldout) soldout.setAttribute('hidden', '');
    } else {
      if (!soldout) {
        soldout = document.createElement('span');
        soldout.className = 'sv-price__soldout';
        priceEl.appendChild(soldout);
      }
      soldout.textContent = soldoutLabel;
      soldout.removeAttribute('hidden');
    }
    priceEl.classList.toggle('sv-price--sold-out', !available);
  }

  /* Variant select: update price, button state and the ?variant= URL param */
  function initVariants(root) {
    root.querySelectorAll('[data-sv-variant-select]').forEach(function (select) {
      if (!once(select)) return;
      var section = select.closest('[data-sv-product]');
      if (!section) return;

      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var price = option.getAttribute('data-price');
        var compare = option.getAttribute('data-compare') || '';
        var available = option.getAttribute('data-available') === 'true';
        var addBtn = section.querySelector('[data-sv-add-to-cart]');
        var soldoutLabel =
          (addBtn && addBtn.getAttribute('data-label-soldout')) ||
          (window.SV && window.SV.strings && window.SV.strings.soldOut) ||
          'Sold Out';

        section.querySelectorAll('[data-sv-product-price] .sv-price').forEach(function (priceEl) {
          updatePrice(priceEl, price, compare, available, soldoutLabel);
        });
        section.querySelectorAll('[data-sv-add-to-cart]').forEach(function (btn) {
          btn.disabled = !available;
          var label = available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-soldout');
          if (label) btn.textContent = label;
        });

        if (window.history && window.history.replaceState && option.value) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', option.value);
            window.history.replaceState({}, '', url.toString());
          } catch (err) {
            /* ignore */
          }
        }
      });
    });
  }

  /* Description: hide the excerpt while the full text is expanded */
  document.addEventListener('sv:toggle', function (event) {
    var detail = event.detail || {};
    var target = detail.target;
    if (!target || !target.hasAttribute || !target.hasAttribute('data-sv-product-full')) return;
    var excerpt = document.getElementById(target.getAttribute('data-sv-product-full'));
    if (!excerpt) return;
    if (detail.expanded) {
      excerpt.setAttribute('hidden', '');
    } else {
      excerpt.removeAttribute('hidden');
    }
  });

  /* Theme editor: open an accordion when its block is selected */
  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var details = target.closest('details.sv-product__accordion');
    if (details) details.open = true;
  });

  function init(root) {
    root = root && root.querySelectorAll ? root : document;
    initGallery(root);
    initVariants(root);
    initRatingLinks(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var DEFAULT_PAGE_SIZE = 3;
  var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;

  function isDesktop() {
    return desktopQuery ? desktopQuery.matches : true;
  }

  function onMediaChange(handler) {
    if (!desktopQuery) return;
    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', handler);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(handler);
    }
  }

  function offMediaChange(handler) {
    if (!desktopQuery) return;
    if (typeof desktopQuery.removeEventListener === 'function') {
      desktopQuery.removeEventListener('change', handler);
    } else if (typeof desktopQuery.removeListener === 'function') {
      desktopQuery.removeListener(handler);
    }
  }

  function initReviews(section) {
    if (section.dataset.svReviewsReady === 'true') return;
    section.dataset.svReviewsReady = 'true';

    var pageSize = parseInt(section.getAttribute('data-page-size'), 10) || DEFAULT_PAGE_SIZE;
    var list = section.querySelector('[data-reviews-list]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-review-index]'));
    var pageButtons = Array.prototype.slice.call(section.querySelectorAll('[data-reviews-page]'));
    var prev = section.querySelector('[data-reviews-prev]');
    var next = section.querySelector('[data-reviews-next]');
    var more = section.querySelector('[data-reviews-more]');
    var moreWrap = more ? more.closest('.sv-reviews__more') : null;
    var status = section.querySelector('[data-reviews-status]');

    var total = cards.length;
    var pageCount = Math.max(1, Math.ceil(total / pageSize));
    var state = { page: 1, shown: pageSize };

    function announce(text) {
      if (status) status.textContent = text;
    }

    function renderDesktop() {
      var start = (state.page - 1) * pageSize;
      var end = start + pageSize;
      cards.forEach(function (card, i) {
        card.hidden = !(i >= start && i < end);
      });
      pageButtons.forEach(function (btn) {
        var p = parseInt(btn.getAttribute('data-reviews-page'), 10);
        var active = p === state.page;
        btn.classList.toggle('is-active', active);
        if (active) {
          btn.setAttribute('aria-current', 'page');
        } else {
          btn.removeAttribute('aria-current');
        }
      });
      if (prev) {
        prev.disabled = state.page <= 1;
        prev.setAttribute('aria-disabled', prev.disabled ? 'true' : 'false');
      }
      if (next) {
        next.disabled = state.page >= pageCount;
        next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
      }
    }

    function renderMobile() {
      cards.forEach(function (card, i) {
        card.hidden = i >= state.shown;
      });
      var allShown = state.shown >= total;
      if (more) more.hidden = allShown;
      /* Hide the wrapper too: it is display:flex with a top margin once the
         section is ready, so an empty wrapper would leave a stray gap. */
      if (moreWrap) moreWrap.hidden = allShown;
    }

    function render() {
      if (isDesktop()) {
        renderDesktop();
      } else {
        renderMobile();
      }
    }

    function goTo(page, scroll) {
      var target = Math.min(Math.max(1, page), pageCount);
      if (target === state.page && !scroll) return;
      state.page = target;
      render();
      announce('Page ' + state.page + ' of ' + pageCount);
      if (scroll && list) {
        var rect = list.getBoundingClientRect();
        if (rect.top < 0) {
          list.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    function loadMore() {
      /* Remember how many were visible before so focus lands on the first
         newly revealed card even when the total is not a multiple of pageSize. */
      var prevShown = Math.min(state.shown, total);
      state.shown = Math.min(total, state.shown + pageSize);
      render();
      announce('Showing ' + Math.min(state.shown, total) + ' of ' + total + ' reviews');
      var firstNew = cards[prevShown];
      if (firstNew && typeof firstNew.focus === 'function') {
        firstNew.setAttribute('tabindex', '-1');
        firstNew.focus({ preventScroll: true });
      }
    }

    pageButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(parseInt(btn.getAttribute('data-reviews-page'), 10), true);
      });
    });

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(state.page - 1, true);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(state.page + 1, true);
      });
    }

    if (more) {
      more.addEventListener('click', function (event) {
        event.preventDefault();
        loadMore();
      });
    }

    /* Re-render when the breakpoint flips. The shared MediaQueryList outlives
       the section in the theme editor (every shopify:section:load re-renders
       it), so the handler unregisters itself once this section has left the
       DOM, and shopify:section:unload removes it eagerly. */
    function isConnected() {
      return typeof section.isConnected === 'boolean' ? section.isConnected : document.contains(section);
    }

    function onChange() {
      if (!isConnected()) {
        offMediaChange(onChange);
        return;
      }
      render();
    }

    onMediaChange(onChange);

    var wrapper = section.closest ? section.closest('.shopify-section') : null;
    if (wrapper) {
      wrapper.addEventListener('shopify:section:unload', function handleUnload() {
        offMediaChange(onChange);
        wrapper.removeEventListener('shopify:section:unload', handleUnload);
      });
    }

    /* Theme editor: reveal the page / batch that contains a selected review block. */
    section.addEventListener('shopify:block:select', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var card = target.closest('[data-review-index]');
      if (!card) return;
      var index = parseInt(card.getAttribute('data-review-index'), 10) || 0;
      if (isDesktop()) {
        goTo(Math.floor(index / pageSize) + 1, false);
      } else {
        state.shown = Math.max(state.shown, index + 1);
        render();
      }
    });

    section.classList.add('is-ready');
    render();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-sv-reviews]').forEach(initReviews);
    if (scope !== document && scope.matches && scope.matches('[data-sv-reviews]')) {
      initReviews(scope);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-positions"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var PAD = 16;

  /* Keep the active pill visible inside the mobile scroller (horizontal only,
     never scrolls the page). */
  function revealActiveTab(container) {
    var tab = container.querySelector('[data-sv-tab].is-active');
    var list = tab ? tab.closest('.sv-positions__tabs') : null;
    if (!tab || !list || list.scrollWidth <= list.clientWidth + 1) return;
    var tr = tab.getBoundingClientRect();
    var lr = list.getBoundingClientRect();
    var delta = 0;
    if (tr.left < lr.left + PAD) {
      delta = tr.left - lr.left - PAD;
    } else if (tr.right > lr.right - PAD) {
      delta = tr.right - lr.right + PAD;
    }
    if (delta !== 0) list.scrollBy({ left: delta, behavior: 'smooth' });
  }

  document.addEventListener('sv:tabs:change', function (event) {
    var container = event.detail && event.detail.container;
    if (!container || !container.classList || !container.classList.contains('sv-positions__grid')) return;
    revealActiveTab(container);
  });

  /* Theme editor: selecting a block activates its tab. */
  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    var tab = target && target.closest ? target.closest('.sv-positions__tab') : null;
    if (tab) tab.click();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
